import React, { forwardRef, useState } from "react";
import InputBase from "@mui/material/InputBase";
import "./input.scss";
import InfoIcon from "@mui/icons-material/Info";
import classNames from "classnames";
import Box from "@mui/material/Box";
import Label from "../label/Label";
import Grid from "@mui/material/Grid";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { InputAdornment } from "@mui/material";
import { CustomTooltip } from "../tooltip/Tooltip";

export const Input = forwardRef(
  (
    {
      value,
      showLabel,
      error,
      label,
      actionLabel,
      actionLabelClick,
      fullWidth,
      customClass,
      isIcon,
      iconContent,
      isPasswordVisible,
      isFromDetailPage,
      ...props
    },
    ref
  ) => {
    const [inputType, setInputType] = useState("password");
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (event) => {
      setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const handleKeyDown = (e) => {
      if (e.keyCode === 13) {
        actionLabelClick();
      }
    };

    const classes = classNames(
      "input-element",
      isPasswordVisible && "password-input",
      customClass
    );

    const renderWithIcon = () => {
      return isIcon ? (
        <Box style={{ display: "flex", flexDirection: "row" }}>
          <Label>{label}</Label>
          <InfoIcon className="label-with-icon" onClick={handleClick} />
        </Box>
      ) : (
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Label>{label}</Label>
          {actionLabel && (
            <Label
              className="action-label"
              tabIndex={0}
              onKeyDown={handleKeyDown}
              onClick={() => actionLabelClick()}
            >
              {actionLabel}
            </Label>
          )}
        </Grid>
      );
    };

    const toggleShowPassword = () => {
      if (inputType === "password") {
        if (props?.from === "withdrawalLink" && value === "dummyVal") {
          props?.handleShowPassword("eye-icon").then((res) => {
            if (res) setInputType("text");
          });
        } else {
          setInputType("text");
        }
      } else {
        setInputType("password");
      }
    };

    const renderValue =
      props?.from === "withdrawalLink" &&
      inputType !== "text" &&
      isFromDetailPage
        ? value.slice(0, 8)
        : value;

    return (
      <Box className={classes} sx={{ width: 1 }}>
        {showLabel && renderWithIcon()}
        <InputBase
          inputRef={ref}
          {...props}
          type={isPasswordVisible ? inputType : props.type}
          value={renderValue}
          error={error}
          fullWidth={fullWidth}
          endAdornment={
            props?.endAdornment
              ? props.endAdornment
              : isPasswordVisible && (
                  <InputAdornment
                    className="password-visibility-icon"
                    position="end"
                  >
                    <CustomTooltip
                      arrow={false}
                      placement={props.position || "right"}
                      text={
                        <>{inputType === "text" ? "Hide" : "Show "} password</>
                      }
                    >
                      {inputType === "text" ? (
                        <VisibilityOffIcon onClick={toggleShowPassword} />
                      ) : (
                        <VisibilityIcon onClick={toggleShowPassword} />
                      )}
                    </CustomTooltip>
                  </InputAdornment>
                )
          }
        />
      </Box>
    );
  }
);
